import 'leaflet'
import Vue from 'vue'

import MapContextObjectMenu from '../../components/map-context-object-menu'
import MapContextObject from '../../components/map-context-object'
import MapContextRelation from '../../components/map-context-relation'
import BaseContextMenu from './BaseContextMenu'

function ContextMenu() {
  this.addHooksToClasses()
  this.addContextMenus()
}

ContextMenu.prototype = {
  addHooksToClasses: function () {
    // intercept event on leaflet elements
    let classes = [L.Marker, L.Path, L.Polyline],
      defaultOptions = {
        ContextObject: false,
        ContextRelation: false,
      },
      cls,
      i,
      l
    for (i = 0, l = classes.length; i < l; i++) {
      cls = classes[i]

      defaultOptions = {
        contextMenu: true,
      }

      // L.Class should probably provide an empty options hash, as it does not test
      // for it here and add if needed
      if (!cls.prototype.options) {
        cls.prototype.options = defaultOptions
      } else {
        cls.mergeOptions(defaultOptions)
      }

      cls.addInitHook(function () {
        if (this.options.contextMenu) {
          this.on(
            'contextmenu',
            function (e) {
              this._map.fire('contextmenu.open', {
                event: e,
                layer: this,
              })
            },
            this
          )
        }
      })
    }
  },
  addContextMenus: function () {
    L.Map.MapContextObjectMenu = BaseContextMenu.extend({
      acceptShowFromLayer: function (options) {
        let { layer } = options
        return layer instanceof L.Marker
      },
      acceptShow: function () {
        return false
      },
      getVueComponent: function () {
        return new Vue(MapContextObjectMenu)
      },
    })
    L.Map.addInitHook('addHandler', 'contextmenu', L.Map.MapContextObjectMenu)

    L.Map.ContextObject = BaseContextMenu.extend({
      acceptShowFromLayer: function () {
        return false
      },
      acceptShow: function () {
        return true
      },
      getVueComponent: function () {
        return new Vue(MapContextObject)
      },
    })
    L.Map.addInitHook('addHandler', 'contextmenu', L.Map.ContextObject)

    L.Map.ContextRelation = BaseContextMenu.extend({
      acceptShowFromLayer: function (options) {
        let { layer } = options
        // TODO: detect  L.polyline
        if (layer instanceof L.Polyline && layer._parts[0].length === 2) {
          return true
        }
        return false
      },
      acceptShow: function () {
        return false
      },
      getVueComponent: function () {
        return new Vue(MapContextRelation)
      },
    })
    L.Map.addInitHook('addHandler', 'contextmenu', L.Map.ContextRelation)
  },
}

const menu = new ContextMenu()
export default menu
